import { BookableBundle, BookableBundleIdentifier } from '../../types/BookableServiceBundleConfig';
import areBookableBundlesEnabled from './areBookableBundlesEnabled';
import getSupportedBookableBundlesForPartnerOrganization from './getSupportedBookableBundlesForPartnerOrganization';

/**
 * Returns the bookable bundle configuration for a given bundle, identified uniquely by a partner organization
 * and a display name.
 *
 * @param bundleIdentifier - An object containing a partner organization and a display name for a bundle.
 * @returns The bookable bundle configuration for the given bundle, or undefined if no such bundle exists.
 * */
export default function getBundleConfigFromBundleIdentifier(
  bundleIdentifier: BookableBundleIdentifier,
): BookableBundle | undefined {
  if (!areBookableBundlesEnabled()) {
    throw new Error('Bundles are not yet supported');
  }
  const supportedBookableBundles = getSupportedBookableBundlesForPartnerOrganization(
    bundleIdentifier.partnerOrganization,
  );
  const bundleConfig = supportedBookableBundles.find(
    (supportedBundle) => supportedBundle.displayName === bundleIdentifier.displayName,
  );
  return bundleConfig;
}
